import { render, staticRenderFns } from "./StatsModal.vue?vue&type=template&id=7ab54558&"
import script from "./StatsModal.vue?vue&type=script&lang=js&"
export * from "./StatsModal.vue?vue&type=script&lang=js&"
import style0 from "./StatsModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports